export default __webpack_public_path__ + "static/media/source-logo.0dd00b42.svg";